<template>
        <TransactionInput :action="action" :transaction-i-d="transactionID" :draft-i-d="draftID"> </TransactionInput>
</template>


<script>
import TransactionInput from "../../components/TransactionInput"
export default {
	name: "ReplaceTransaction",
	components: {TransactionInput},
	data(){
		return{
			action:"replace" ,
			transactionID: location.pathname?.split("/")?.reverse()?.[1],
			draftID:null,
		}
	},
}
</script>
